import * as faceapi from "face-api.js";

export async function loadFaceApiModels() {
  const MODEL_URL = process.env.PUBLIC_URL + "/models";
  try {
    await Promise.all([
      faceapi.loadTinyFaceDetectorModel(MODEL_URL),
      faceapi.loadFaceLandmarkModel(MODEL_URL),
      faceapi.loadFaceRecognitionModel(MODEL_URL),
    ]);
    return { message: "Success", hasError: false };
  } catch (error) {
    // toast.dismiss();
    // toast.error(`Failed to load Face API models: ${error.message}`);
    return { message: "Error", hasError: true, error };
  }
}